import { createBrowserRouter } from 'react-router-dom'
import { AppShell } from '@/components/layout/AppShell'
import { AreaPricingPage } from '@/features/area-pricing/AreaPricingPage'
import { LoginPage } from '@/features/auth/LoginPage'
import { ProtectedRoute } from '@/features/auth/ProtectedRoute'
import { DashboardPage } from '@/features/dashboard/DashboardPage'
import { DriversPage } from '@/features/drivers/DriversPage'
import { InstapayConfigPage } from '@/features/payments/InstapayConfigPage'
import { PenaltiesPage } from '@/features/penalties/PenaltiesPage'
import { PromoCodesPage } from '@/features/promo-codes/PromoCodesPage'
import { RatingsPage } from '@/features/ratings/RatingsPage'
import { RefundsPage } from '@/features/refunds/RefundsPage'
import { ReportingPage } from '@/features/reporting/ReportingPage'
import { TripEditsPage } from '@/features/trip-edits/TripEditsPage'
import { TripRequestsPage } from '@/features/trip-requests/TripRequestsPage'
import { TripsPage } from '@/features/trips/TripsPage'
import { UsersPage } from '@/features/users/UsersPage'
import { ForbiddenPage, NotFoundPage, RouteErrorBoundary } from './ErrorPages'

/**
 * Every application route sits behind {@link ProtectedRoute} and inside the
 * shell; login and the error screens stand alone. Each level carries an error
 * element, so a failure is contained to the smallest area that can still
 * explain itself.
 */
export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/forbidden',
    element: <ForbiddenPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    element: <ProtectedRoute />,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        element: <AppShell />,
        errorElement: <RouteErrorBoundary />,
        children: [
          { index: true, element: <DashboardPage />, errorElement: <RouteErrorBoundary /> },
          { path: 'reporting', element: <ReportingPage />, errorElement: <RouteErrorBoundary /> },
          { path: 'trip-requests', element: <TripRequestsPage />, errorElement: <RouteErrorBoundary /> },
          { path: 'trip-edits', element: <TripEditsPage />, errorElement: <RouteErrorBoundary /> },
          { path: 'trips', element: <TripsPage />, errorElement: <RouteErrorBoundary /> },
          { path: 'ratings', element: <RatingsPage />, errorElement: <RouteErrorBoundary /> },
          { path: 'drivers', element: <DriversPage />, errorElement: <RouteErrorBoundary /> },
          { path: 'users', element: <UsersPage />, errorElement: <RouteErrorBoundary /> },
          { path: 'promo-codes', element: <PromoCodesPage />, errorElement: <RouteErrorBoundary /> },
          { path: 'refunds', element: <RefundsPage />, errorElement: <RouteErrorBoundary /> },
          { path: 'penalties', element: <PenaltiesPage />, errorElement: <RouteErrorBoundary /> },
          { path: 'instapay', element: <InstapayConfigPage />, errorElement: <RouteErrorBoundary /> },
          { path: 'area-pricing', element: <AreaPricingPage />, errorElement: <RouteErrorBoundary /> },
          { path: '*', element: <NotFoundPage /> },
        ],
      },
    ],
  },
])
